module.exports = __webpack_public_path__ + "static/media/bg-shorten-desktop.27d3cd28.svg";